import {
    heroOutline24AdjustmentsVertical,
    heroOutline24ArchiveBox,
    heroOutline24ArrowDownOnSquare,
    heroOutline24ArrowDownOnSquareStack,
    heroOutline24ArrowDownTray,
    heroOutline24ArrowLeftCircle,
    heroOutline24ArrowLeftOnRectangle,
    heroOutline24ArrowPath,
    heroOutline24ArrowRightCircle,
    heroOutline24ArrowRightOnRectangle,
    heroOutline24ArrowSmallLeft,
    heroOutline24ArrowSmallRight,
    heroOutline24ArrowSmallUp,
    heroOutline24ArrowsPointingOut,
    heroOutline24ArrowsRightLeft,
    heroOutline24ArrowTopRightOnSquare,
    heroOutline24ArrowUpTray,
    heroOutline24AtSymbol,
    heroOutline24Bars3BottomLeft,
    heroOutline24Bars3CenterLeft,
    heroOutline24Bars4,
    heroOutline24Beaker,
    heroOutline24Bell,
    heroOutline24Bookmark,
    heroOutline24BookOpen,
    heroOutline24BuildingOffice,
    heroOutline24Calendar,
    heroOutline24CalendarDays,
    heroOutline24ChartBar,
    heroOutline24ChatBubbleBottomCenterText,
    heroOutline24ChatBubbleLeftRight,
    heroOutline24Check,
    heroOutline24CheckCircle,
    heroOutline24ChevronDown,
    heroOutline24ChevronLeft,
    heroOutline24ChevronRight,
    heroOutline24ChevronUp,
    heroOutline24CircleStack,
    heroOutline24Clipboard,
    heroOutline24ClipboardDocumentCheck,
    heroOutline24Clock,
    heroOutline24Cog6Tooth,
    heroOutline24Document,
    heroOutline24DocumentArrowUp,
    heroOutline24DocumentDuplicate,
    heroOutline24DocumentText,
    heroOutline24EllipsisHorizontal,
    heroOutline24EllipsisVertical,
    heroOutline24Envelope,
    heroOutline24ExclamationCircle,
    heroOutline24ExclamationTriangle,
    heroOutline24Eye,
    heroOutline24EyeSlash,
    heroOutline24Flag,
    heroOutline24Folder,
    heroOutline24FolderPlus,
    heroOutline24Funnel,
    heroOutline24GlobeEuropeAfrica,
    heroOutline24HandThumbDown,
    heroOutline24HandThumbUp,
    heroOutline24Hashtag,
    heroOutline24Heart,
    heroOutline24Home,
    heroOutline24Identification,
    heroOutline24InformationCircle,
    heroOutline24Lifebuoy,
    heroOutline24Link,
    heroOutline24LockClosed,
    heroOutline24LockOpen,
    heroOutline24MagnifyingGlass,
    heroOutline24MapPin,
    heroOutline24Megaphone,
    heroOutline24Minus,
    heroOutline24PaperAirplane,
    heroOutline24PaperClip,
    heroOutline24Pause,
    heroOutline24PauseCircle,
    heroOutline24Pencil,
    heroOutline24Phone,
    heroOutline24Photo,
    heroOutline24Play,
    heroOutline24PlayCircle,
    heroOutline24Plus,
    heroOutline24PlusCircle,
    heroOutline24PresentationChartLine,
    heroOutline24QrCode,
    heroOutline24QuestionMarkCircle,
    heroOutline24RocketLaunch,
    heroOutline24Share,
    heroOutline24Sparkles,
    heroOutline24Square2Stack,
    heroOutline24Star,
    heroOutline24Stop,
    heroOutline24StopCircle,
    heroOutline24Tag,
    heroOutline24Trash,
    heroOutline24User,
    heroOutline24UserGroup,
    heroOutline24UserPlus,
    heroOutline24Users,
    heroOutline24ViewColumns,
    heroOutline24WrenchScrewdriver,
    heroOutline24XCircle,
    heroOutline24XMark,
    heroSolid20Funnel,
    heroSolid24AdjustmentsVertical,
    heroSolid24ArchiveBox,
    heroSolid24ArrowDownOnSquare,
    heroSolid24ArrowDownOnSquareStack,
    heroSolid24ArrowDownTray,
    heroSolid24ArrowLeftCircle,
    heroSolid24ArrowPath,
    heroSolid24ArrowRightCircle,
    heroSolid24ArrowRightOnRectangle,
    heroSolid24ArrowSmallDown,
    heroSolid24ArrowSmallLeft,
    heroSolid24ArrowSmallRight,
    heroSolid24ArrowSmallUp,
    heroSolid24ArrowsUpDown,
    heroSolid24ArrowTopRightOnSquare,
    heroSolid24ArrowUpTray,
    heroSolid24AtSymbol,
    heroSolid24Bars3BottomLeft,
    heroSolid24Bars3CenterLeft,
    heroSolid24Bars4,
    heroSolid24Beaker,
    heroSolid24Bell,
    heroSolid24BuildingOffice,
    heroSolid24Calendar,
    heroSolid24CalendarDays,
    heroSolid24ChartBar,
    heroSolid24ChatBubbleLeftRight,
    heroSolid24Check,
    heroSolid24CheckCircle,
    heroSolid24ChevronDoubleLeft,
    heroSolid24ChevronDoubleRight,
    heroSolid24ChevronDown,
    heroSolid24ChevronLeft,
    heroSolid24ChevronRight,
    heroSolid24CircleStack,
    heroSolid24Clipboard,
    heroSolid24ClipboardDocumentCheck,
    heroSolid24Clock,
    heroSolid24Cog6Tooth,
    heroSolid24Document,
    heroSolid24DocumentDuplicate,
    heroSolid24DocumentText,
    heroSolid24EllipsisHorizontal,
    heroSolid24EllipsisVertical,
    heroSolid24Envelope,
    heroSolid24ExclamationCircle,
    heroSolid24ExclamationTriangle,
    heroSolid24Eye,
    heroSolid24EyeSlash,
    heroSolid24Flag,
    heroSolid24Folder,
    heroSolid24GlobeEuropeAfrica,
    heroSolid24HandThumbDown,
    heroSolid24HandThumbUp,
    heroSolid24Hashtag,
    heroSolid24Heart,
    heroSolid24Home,
    heroSolid24Identification,
    heroSolid24InformationCircle,
    heroSolid24Lifebuoy,
    heroSolid24Link,
    heroSolid24LockClosed,
    heroSolid24MagnifyingGlass,
    heroSolid24MapPin,
    heroSolid24Megaphone,
    heroSolid24Minus,
    heroSolid24PaperAirplane,
    heroSolid24PaperClip,
    heroSolid24PauseCircle,
    heroSolid24Pencil,
    heroSolid24Photo,
    heroSolid24PlayCircle,
    heroSolid24Plus,
    heroSolid24PlusCircle,
    heroSolid24PresentationChartLine,
    heroSolid24QrCode,
    heroSolid24QuestionMarkCircle,
    heroSolid24RocketLaunch,
    heroSolid24Share,
    heroSolid24Sparkles,
    heroSolid24Square2Stack,
    heroSolid24Star,
    heroSolid24Stop,
    heroSolid24StopCircle,
    heroSolid24Tag,
    heroSolid24Trash,
    heroSolid24User,
    heroSolid24UserGroup,
    heroSolid24Users,
    heroSolid24ViewColumns,
    heroSolid24WrenchScrewdriver,
    heroSolid24XCircle,
    heroSolid24XMark
} from 'quasar-extras-svg-icons/hero-icons-v2';

export const ICONS_NAME = {
    ADD_LEAD_OUTLINE: 'img:img/customIcons/add-lead-outline.svg',
    ADD_LEAD_SOLID: 'img:img/customIcons/add-lead-solid.svg',
    AGREEMENT_OUTLINE: 'img:img/customIcons/agreement-outline.svg',
    AGREEMENT_SOLID_ACTIVE: 'img:img/customIcons/agreement-solid-active.svg',
    ALIENATION_TEXT_OUTLINE: heroOutline24Bars3BottomLeft,
    ALIENATION_TEXT_SOLID: heroSolid24Bars3BottomLeft,
    ALLIANCE_OUTLINE: 'img:img/customIcons/alliance-outline.svg',
    ALLIANCE_SOLID_ACTIVE: 'img:img/customIcons/alliance-solid-active.svg',
    ANCHOR_SIMPLE_BOLD: 'img:img/customIcons/anchor-simple-bold.svg',
    ARCHIVE_BOX_OUTLINE: heroOutline24ArchiveBox,
    ARCHIVE_BOX_SOLID: heroSolid24ArchiveBox,
    ARROW_CIRCLE_LEFT_OUTLINE: heroOutline24ArrowLeftCircle,
    ARROW_CIRCLE_LEFT_SOLID: heroSolid24ArrowLeftCircle,
    ARROW_CIRCLE_RIGHT_OUTLINE: heroOutline24ArrowRightCircle,
    ARROW_CIRCLE_RIGHT_SOLID: heroSolid24ArrowRightCircle,
    ARROW_DOWN_SOLID: heroSolid24ArrowSmallDown,
    ARROW_LEFT_OUTLINE: heroOutline24ArrowSmallLeft,
    ARROW_LEFT_RECTANGLE_OUTLINE: heroOutline24ArrowLeftOnRectangle,
    ARROW_LEFT_SOLID: heroSolid24ArrowSmallLeft,
    ARROW_RIGHT_LEFT_OUTLINE: heroOutline24ArrowsRightLeft,
    ARROW_RIGHT_OUTLINE: heroOutline24ArrowSmallRight,
    ARROW_RIGHT_SOLID: heroSolid24ArrowSmallRight,
    ARROW_UP_DOWN: heroSolid24ArrowsUpDown,
    ARROW_UP_OUTLINE: heroOutline24ArrowSmallUp,
    ARROW_UP_SOLID: heroSolid24ArrowSmallUp,
    ARROWS_EXPAND_OUTLINE: heroOutline24ArrowsPointingOut,
    AT_SYMBOL_OUTLINE: heroOutline24AtSymbol,
    AT_SYMBOL_SOLID: heroSolid24AtSymbol,

    BELL_OUTLINE: heroOutline24Bell,
    BELL_SOLID: heroSolid24Bell,
    BOOK_OPEN_OUTLINE: heroOutline24BookOpen,
    BOOKMARK_OUTLINE: heroOutline24Bookmark,
    BRAND_INPART_ICON: 'img:img/customIcons/brand-inpart-icon.svg',

    CALENDAR_DAYS_OUTLINE: heroOutline24CalendarDays,
    CALENDAR_DAYS_SOLID: heroSolid24CalendarDays,
    CALENDAR_OUTLINE: heroOutline24Calendar,
    CALENDAR_SOLID: heroSolid24Calendar,
    CAMPAIGN_OUTLINE: heroOutline24Megaphone,
    CAMPAIGN_SOLID: heroSolid24Megaphone,
    CARD_LIST: 'img:img/customIcons/card-list.svg',
    CHART_BAR_OUTLINE: heroOutline24ChartBar,
    CHART_BAR_SOLID: heroSolid24ChartBar,
    CHECK_CIRCLE_OUTLINE: heroOutline24CheckCircle,
    CHECK_CIRCLE_SOLID: heroSolid24CheckCircle,
    CHECK_OUTLINE: heroOutline24Check,
    CHECK_SOLID: heroSolid24Check,
    CHECKBOX_ICON: 'img:img/customIcons/checkbox-done.svg',
    CHEVRON_DOUBLE_LEFT_SOLID: heroSolid24ChevronDoubleLeft,
    CHEVRON_DOUBLE_RIGHT_SOLID: heroSolid24ChevronDoubleRight,
    CHEVRON_DOWN_OUTLINE: heroOutline24ChevronDown,
    CHEVRON_DOWN_SOLID: heroSolid24ChevronDown,
    CHEVRON_LEFT_OUTLINE: heroOutline24ChevronLeft,
    CHEVRON_LEFT_SOLID: heroSolid24ChevronLeft,
    CHEVRON_RIGHT_OUTLINE: heroOutline24ChevronRight,
    CHEVRON_RIGHT_SOLID: heroSolid24ChevronRight,
    CHEVRON_UP_OUTLINE: heroOutline24ChevronUp,
    CLIPBOARD_OUTLINE: heroOutline24Clipboard,
    CLIPBOARD_SOLID: heroSolid24Clipboard,
    CLIPBOARD_DOCUMENT_CHECK_OUTLINE: heroOutline24ClipboardDocumentCheck,
    CLIPBOARD_DOCUMENT_CHECK_SOLID: heroSolid24ClipboardDocumentCheck,
    CLOCK_OUTLINE: heroOutline24Clock,
    CLOCK_SOLID: heroSolid24Clock,
    COG_OUTLINE: heroOutline24Cog6Tooth,
    COG_SOLID: heroSolid24Cog6Tooth,
    COLUMNS_OUTLINE: heroOutline24ViewColumns,
    COLUMNS_SOLID: heroSolid24ViewColumns,
    COMMENT_REPLY_OUTLINE: heroOutline24ChatBubbleBottomCenterText,
    COMMENTS_ICON: 'img:img/customIcons/comments-icon.svg',
    COMMENTS_OUTLINE: heroOutline24ChatBubbleLeftRight,
    COMMENTS_SOLID: heroSolid24ChatBubbleLeftRight,
    COMPANY_OUTLINE: heroOutline24BuildingOffice,
    COMPANY_SOLID: heroSolid24BuildingOffice,
    COMPLETE_ICON: 'img:img/customIcons/complete-icon.svg',
    CONSUMER_HEALTH_OUTLINE: heroOutline24Heart,
    CONSUMER_HEALTH_Solid: heroSolid24Heart,
    CONTACT_OUTLINE: heroOutline24User,
    CONTACT_PLUS_OUTLINE: heroOutline24UserPlus,
    CONTACT_SOLID: heroSolid24User,
    COPY_ICON: 'img:img/customIcons/copy-icon.svg',
    COPY_OUTLINE: heroOutline24DocumentDuplicate,
    COPY_SOLID: heroSolid24DocumentDuplicate,
    COPY_TEXT_OUTLINE: heroOutline24Square2Stack,
    COPY_TEXT_SOLID: heroSolid24Square2Stack,
    CORTELLIS: 'img:img/customIcons/cortellis.svg',
    CUSTOMIZABLE_OUTLINE: heroOutline24WrenchScrewdriver,
    CUSTOMIZABLE_SOLID: heroSolid24WrenchScrewdriver,

    DANGER_OUTLINE: heroOutline24ExclamationCircle,
    DANGER_SOLID: heroSolid24ExclamationCircle,
    DASHBOARD_OUTLINE: heroOutline24ChartBar,
    DASHBOARD_SOLID: heroSolid24ChartBar,
    DATABASE_OUTLINE: heroOutline24CircleStack,
    DATABASE_SOLID: heroSolid24CircleStack,
    DELETE_OUTLINE: heroOutline24Trash,
    DELETE_SOLID: heroSolid24Trash,
    DOCUMENT_ADD: 'img:img/customIcons/add-document.svg',
    DOCUMENT_ARROW_UP_OUTLINE: heroOutline24DocumentArrowUp,
    DOCUMENT_TEXT_OUTLINE: heroOutline24DocumentText,
    DOCUMENT_TEXT_SOLID: heroSolid24DocumentText,
    DOWNLOAD_OUTLINE: heroOutline24ArrowDownTray,
    DOWNLOAD_SOLID: heroSolid24ArrowDownTray,
    DRAGGER_DISABLED: 'img:img/customIcons/draggable-disabled.svg',
    DRAGGER: 'img:img/customIcons/draggable.svg',

    EDIT_OUTLINE: heroOutline24Pencil,
    EDIT_SOLID: heroSolid24Pencil,
    ELLIPSIS_OUTLINE: heroOutline24EllipsisHorizontal,
    ELLIPSIS_SOLID: heroSolid24EllipsisHorizontal,
    EMAIL_OUTLINE: heroOutline24Envelope,
    EMAIL_SOLID: heroSolid24Envelope,
    EVALUATE: 'img:img/logo/evaluate-logo.svg',
    EXPORT_OUTLINE: heroOutline24ArrowUpTray,
    EXTERNAL_LINK_OUTLINE: heroOutline24ArrowTopRightOnSquare,
    EXTERNAL_LINK_SOLID: heroSolid24ArrowTopRightOnSquare,
    EYE_OUTLINE: heroOutline24Eye,
    EYE_SLASH_OUTLINE: heroOutline24EyeSlash,
    EYE_SLASH_SOLID: heroSolid24EyeSlash,
    EYE_SOLID: heroSolid24Eye,

    FILE_ICON_DEFAULT: 'img:img/customIcons/file-type/default-type.svg',
    FILE_ICON_EXCEL: 'img:img/customIcons/file-type/excel-type.svg',
    FILE_ICON_IMG: 'img:img/customIcons/file-type/img-type.svg',
    FILE_ICON_PDF: 'img:img/customIcons/file-type/pdf-type.svg',
    FILE_ICON_POWERPOINT: 'img:img/customIcons/file-type/powerpoint-type.svg',
    FILE_ICON_WORD: 'img:img/customIcons/file-type/word-type.svg',
    FILE_OUTLINE: heroOutline24Document,
    FILE_SOLID: heroSolid24Document,
    FILTER_OUTLINE: heroOutline24AdjustmentsVertical,
    FILTER_SOLID: heroSolid24AdjustmentsVertical,
    FLAG_OUTLINE: heroOutline24Flag,
    FLAG_SOLID: heroSolid24Flag,
    FOLDER_OUTLINE: heroOutline24Folder,
    FOLDER_PLUS_OUTLINE: heroOutline24FolderPlus,
    FOLDER_SOLID: heroSolid24Folder,
    FUNNEL_OUTLINE: heroOutline24Funnel,
    FUNNEL_SOLID: heroSolid20Funnel,

    GLOBE_OUTLINE: heroOutline24GlobeEuropeAfrica,
    GLOBE_SOLID: heroSolid24GlobeEuropeAfrica,
    GOOGLE_DRIVE: 'img:img/customIcons/google_drive.svg',

    HASHTAG_OUTLINE: heroOutline24Hashtag,
    HASHTAG_SOLID: heroSolid24Hashtag,
    HOME_OUTLINE: heroOutline24Home,
    HOME_SOLID: heroSolid24Home,

    IMAGE_OUTLINE: heroOutline24Photo,
    IMAGE_SOLID: heroSolid24Photo,
    IMPORT_OUTLINE: heroOutline24ArrowDownTray,
    IN_DISPUTE_ICON: 'img:img/customIcons/in-dispute-icon.svg',
    INFO_CIRCLE_OUTLINE: heroOutline24InformationCircle,
    INFO_CIRCLE_SOLID: heroSolid24InformationCircle,
    INOVA: 'img:img/logo/menu-inova-icon.svg',
    INPART_ICON: 'img:img/customIcons/inpart.svg',

    JOB_OUTLINE: heroOutline24Identification,
    JOB_SOLID: heroSolid24Identification,

    LIFE_BUOY_OUTLINE: heroOutline24Lifebuoy,
    LIFE_BUOY_SOLID: heroSolid24Lifebuoy,
    LINE_OUTLINE: heroOutline24Minus,
    LINE_SOLID: heroSolid24Minus,
    LINK_OUTLINE: heroOutline24Link,
    LINK_SOLID: heroSolid24Link,
    LINKED: 'img:img/customIcons/link.svg',
    LIST_BULLETS: 'img:img/customIcons/list-bullets.svg',
    LIST_NUMBERS: 'img:img/customIcons/list-numbers.svg',
    LIST_OUTLINE: heroOutline24Bars3CenterLeft,
    LIST_SOLID: heroSolid24Bars3CenterLeft,
    LIST_VALUE: 'img:img/customIcons/list-value.svg',
    LOCATION_OUTLINE: heroOutline24MapPin,
    LOCATION_SOLID: heroSolid24MapPin,
    LOCK_OUTLINE: heroOutline24LockClosed,
    LOCK_SOLID: heroSolid24LockClosed,
    LONG_TEXT: 'img:img/customIcons/long-text.svg',

    MAIN_OWNER: heroSolid24Sparkles,
    MEETINGS_ICON: 'img:img/customIcons/calendar-icon.svg',
    MERGE_OUTLINE: heroOutline24Bars4,
    MERGE_SOLID: heroSolid24Bars4,
    MERGE_TOOL: 'img:img/customIcons/merge-tool.svg',
    MORE_OUTLINE: heroOutline24EllipsisVertical,
    MORE_SOLID: heroSolid24EllipsisVertical,
    NETWORK_OUTLINE: heroOutline24Share,
    NETWORK_SOLID: heroSolid24Share,

    NO_ATTACHMENT: 'img:img/customIcons/no-attachment.svg',
    NO_RESULT: 'img:img/customIcons/no-result.svg',
    NODE_OUTLINE: 'img:img/customIcons/node-outline.svg',
    NODE: 'img:img/customIcons/node-icon.svg',
    NODE_NEGATIVE: 'img:img/customIcons/node-icon-negative.svg',
    NON_FINANCIAL: 'img:img/customIcons/non-financial.svg',
    NON_FINANCIAL_SOLID_ACTIVE: 'img:img/customIcons/non-financial-active.svg',
    NUMBER: 'img:img/customIcons/number.svg',

    OBLIGATION_TYPE: 'img:img/customIcons/obligation-type.svg',
    ONGOING_MONITORING: 'img:img/customIcons/ongoing-monitoring.svg',
    OPEN_OUTLINE: heroOutline24ArrowTopRightOnSquare,
    OPEN_SOLID: heroSolid24ArrowTopRightOnSquare,
    OVERDUE_ICON: 'img:img/customIcons/overdue-icon.svg',

    PAPER_AIRPLANE_OUTLINE: heroOutline24PaperAirplane,
    PAPER_AIRPLANE_SOLID: heroSolid24PaperAirplane,
    PAPER_CLIP_OUTLINE: heroOutline24PaperClip,
    PAPER_CLIP_SOLID: heroSolid24PaperClip,
    PAUSE_CIRCLE_OUTLINE: heroOutline24PauseCircle,
    PAUSE_CIRCLE_SOLID: heroSolid24PauseCircle,
    PAUSE_OUTLINE: heroOutline24Pause,
    PAYMENT_TYPE: 'img:img/customIcons/payment-type.svg',
    PAYMENT: 'img:img/customIcons/payment.svg',
    PENDING_ICON: 'img:img/customIcons/pending-icon.svg',
    PHARMA_ASSET_OUTLINE: heroOutline24Beaker,
    PHARMA_ASSET_SOLID: heroSolid24Beaker,
    PHONE_OUTLINE: heroOutline24Phone,
    PLAY_CIRCLE_OUTLINE: heroOutline24PlayCircle,
    PLAY_CIRCLE_SOLID: heroSolid24PlayCircle,
    PLAY_OUTLINE: heroOutline24Play,
    PLUS_CIRCLE_OUTLINE: heroOutline24PlusCircle,
    PLUS_CIRCLE_SOLID: heroSolid24PlusCircle,
    PRESENTATION_CHART_LINE_OUTLINE: heroOutline24PresentationChartLine,
    PRESENTATION_CHART_LINE_SOLID: heroSolid24PresentationChartLine,
    PLUS_OUTLINE: heroOutline24Plus,
    PLUS_SOLID: heroSolid24Plus,
    PRIVATE_ACCESS_OUTLINE: heroOutline24LockClosed,
    PRIVATE_ACCESS_SOLID: heroSolid24LockClosed,

    QUESTION_MARK_CIRCLE_OUTLINE: heroOutline24QuestionMarkCircle,
    QUESTION_MARK_CIRCLE_SOLID: heroSolid24QuestionMarkCircle,

    RECURRING_PAYMENT_TYPE: 'img:img/customIcons/recurring-payment-type.svg',
    REDO: 'img:img/customIcons/redo.svg',
    REFRESH_OUTLINE: heroOutline24ArrowPath,
    REFRESH_SOLID: heroSolid24ArrowPath,
    RENAME_OUTLINE: 'img:img/customIcons/rename.svg',
    RESOLVED: 'img:img/customIcons/resolved.svg',
    ROCKET_LAUNCH_OUTLINE: heroOutline24RocketLaunch,
    ROCKET_LAUNCH_SOLID: heroSolid24RocketLaunch,
    ROYALTY: 'img:img/customIcons/royalty.svg',

    SAVE_AS_OUTLINE: heroOutline24ArrowDownOnSquareStack,
    SAVE_AS_SOLID: heroSolid24ArrowDownOnSquareStack,
    SAVE_OUTLINE: heroOutline24ArrowDownOnSquare,
    SAVE_SOLID: heroSolid24ArrowDownOnSquare,
    SEARCH_OUTLINE: heroOutline24MagnifyingGlass,
    SEARCH_SOLID: heroSolid24MagnifyingGlass,
    SHAREPOINT: 'img:img/customIcons/sharepoint.svg',
    SHORT_TEXT: 'img:img/customIcons/short-text.svg',
    SIGN_OUT_OUTLINE: heroOutline24ArrowRightOnRectangle,
    SIGN_OUT_SOLID: heroSolid24ArrowRightOnRectangle,
    SPARKLES_OUTLINE: heroOutline24Sparkles,
    SPARKLES_SOLID: heroSolid24Sparkles,
    SQUARE_OUTLINE: heroOutline24Stop,
    SQUARE_SOLID: heroSolid24Stop,
    STAR_OUTLINE: heroOutline24Star,
    STAR_SOLID: heroSolid24Star,
    STOP_CIRCLE_OUTLINE: heroOutline24StopCircle,
    STOP_CIRCLE_SOLID: heroSolid24StopCircle,
    SWITCH_UP_DOWN: 'img:img/customIcons/arrows-down-up.svg',

    TABLE_DELETE_COLUMN: 'img:img/customIcons/delete-column.svg',
    TABLE_DELETE_ROW: 'img:img/customIcons/delete-row.svg',
    TABLE_DELETE_TABLE: 'img:img/customIcons/delete-table.svg',
    TABLE_INSERT_COL_LEFT: 'img:img/customIcons/add-column-left.svg',
    TABLE_INSERT_COL_RIGHT: 'img:img/customIcons/add-column-right.svg',
    TABLE_INSERT_ROW_ABOVE: 'img:img/customIcons/add-row-above.svg',
    TABLE_INSERT_ROW_BELOW: 'img:img/customIcons/add-row-below.svg',
    TABLE_MERGE_CELLS: 'img:img/customIcons/merge-cells.svg',
    TABLE_SPLIT_CELLS: 'img:img/customIcons/split-cells.svg',
    TABLE: 'img:img/customIcons/table.svg',
    TECHNO_SOLUTION_OUTLINE: heroOutline24QrCode,
    TECHNO_SOLUTION_SOLID: heroSolid24QrCode,
    TERMINATED_ICON: 'img:img/customIcons/terminated-icon.svg',
    TEXT_BOLD: 'img:img/customIcons/bold.svg',
    TEXT_ITALIC: 'img:img/customIcons/italic.svg',
    TEXT_UNDERLINE: 'img:img/customIcons/underline.svg',
    THUMB_DOWN_OUTLINE: heroOutline24HandThumbDown,
    THUMB_DOWN_SOLID: heroSolid24HandThumbDown,
    THUMB_UP_OUTLINE: heroOutline24HandThumbUp,
    THUMB_UP_SOLID: heroSolid24HandThumbUp,
    TIMELINE: 'img:img/customIcons/timeline.svg',
    TIMES_CIRCLE_OUTLINE: heroOutline24XCircle,
    TIMES_CIRCLE_SOLID: heroSolid24XCircle,
    TIMES_OUTLINE: heroOutline24XMark,
    TIMES_SOLID: heroSolid24XMark,
    TRIGGERING_EVENT_PAYMENT_TYPE: 'img:img/customIcons/triggering-event-payment-type.svg',
    TYPE_OUTLINE: heroOutline24Tag,
    TYPE_SOLID: heroSolid24Tag,

    UNDER_MITIGATION: 'img:img/customIcons/under-mitigation.svg',
    UNDO: 'img:img/customIcons/undo.svg',
    UNION: 'img:img/customIcons/union.svg',
    UNLINK: 'img:img/customIcons/unlink.svg',
    UNLOCK_OUTLINE: heroOutline24LockOpen,
    UPCOMING_ICON: 'img:img/customIcons/upcoming-icon.svg',
    UPLOAD_OUTLINE: heroOutline24ArrowUpTray,
    UPLOAD_SOLID: heroSolid24ArrowUpTray,
    USER_GROUP_OUTLINE: heroOutline24UserGroup,
    USER_GROUP_SOLID: heroSolid24UserGroup,
    USERS_OUTLINE: heroOutline24Users,
    USERS_SOLID: heroSolid24Users,

    WARNING_OUTLINE: heroOutline24ExclamationTriangle,
    WARNING_SOLID: heroSolid24ExclamationTriangle,

    YOUTUBE: 'img:img/customIcons/youtube.svg',

    ZOOM_IN: 'img:img/customIcons/zoom-in.svg',
    ZOOM_OUT: 'img:img/customIcons/zoom-out.svg',
    ZOOM_RESET: 'img:img/customIcons/zoomReset.svg'
};

export const ICON_PROPS = {
    BTN_XS: {
        size: '12px'
    },
    BTN_SM: {
        size: '16px'
    },
    BTN_LG: {
        size: '20px'
    },
    BTN_LG2: {
        size: '24px'
    },
    BTN_XL: {
        size: '40px'
    },
    MENU: {
        size: '16px',
        color: 'grey-dark',
        class: 'q-mr-xs'
    },
    MAIN_MENU: {
        size: '16px',
        color: 'grey-dark'
    },
    MENU_NEGATIVE: {
        size: '16px',
        color: 'negative',
        class: 'q-mr-xs'
    },
    SIDE: {
        size: '16px'
    }
};

// Define all Icons for the Inpart/Inova brand
const INOVA_ICON = 'img:img/logo/menu-inova-icon.svg';
const INOVA_LOGO = 'img:img/logo/Logo + type.svg';
const INPART_ICON = 'img:img/logo/menu-inpart-icon.svg';
const INPART_LOGO = 'img:img/logo/menu-inpart-logo.svg';

export const BRAND = {
    INOVA_ICON,
    INOVA_LOGO,
    INPART_ICON,
    INPART_LOGO,
    MAIN_ICON: INPART_ICON,
    MAIN_LOGO: INPART_LOGO
};
